module.exports = __webpack_public_path__ + "img/share.3b990969.jpg";